/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformAdminTriggerPasswordReset } from '../../models/platform-admin-trigger-password-reset';
import { PlatformApiResultOfUserAccountDto } from '../../models/platform-api-result-of-user-account-dto';

export interface PostUseraccountsActionAdminTriggerPasswordReset$Params {
      body: PlatformAdminTriggerPasswordReset
}

export function postUseraccountsActionAdminTriggerPasswordReset(http: HttpClient, rootUrl: string, params: PostUseraccountsActionAdminTriggerPasswordReset$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserAccountDto>> {
  const rb = new RequestBuilder(rootUrl, postUseraccountsActionAdminTriggerPasswordReset.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserAccountDto>;
    })
  );
}

postUseraccountsActionAdminTriggerPasswordReset.PATH = '/api/useraccounts/action/admin-trigger-password-reset';
